import { render } from "./EditPo.vue?vue&type=template&id=efcaca2a"
import script from "./EditPo.vue?vue&type=script&lang=js"
export * from "./EditPo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__